export let VideoUrlType;
(function (VideoUrlType) {
  VideoUrlType["TRAILER"] = "TRAILER";
  VideoUrlType["CLIP"] = "CLIP";
  VideoUrlType["CONTENT"] = "CONTENT";
  VideoUrlType["AUTOGENERATED_TRAILER"] = "AUTOGENERATED_TRAILER";
})(VideoUrlType || (VideoUrlType = {}));
//# sourceMappingURL=video-url-type.js.map